/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AzureApiStrictHttpResponse } from '../../azure-api-strict-http-response';
import { AzureApiRequestBuilder } from '../../azure-api-request-builder';

import { VendorAuctionWorksheetAttachmentDto } from '../../models/vendor-auction-worksheet-attachment-dto';

export interface ApiVendorVendorAuctionGetVendorAttachmentGet$Params {
  auctionId?: string;
  vendorId?: string;

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiVendorVendorAuctionGetVendorAttachmentGet(http: HttpClient, rootUrl: string, params?: ApiVendorVendorAuctionGetVendorAttachmentGet$Params, context?: HttpContext): Observable<AzureApiStrictHttpResponse<Array<VendorAuctionWorksheetAttachmentDto>>> {
  const rb = new AzureApiRequestBuilder(rootUrl, apiVendorVendorAuctionGetVendorAttachmentGet.PATH, 'get');
  if (params) {
    rb.query('auctionId', params.auctionId, {});
    rb.query('vendorId', params.vendorId, {});
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AzureApiStrictHttpResponse<Array<VendorAuctionWorksheetAttachmentDto>>;
    })
  );
}

apiVendorVendorAuctionGetVendorAttachmentGet.PATH = '/api/vendor/vendor-auction/GetVendorAttachment';
